import React from "react";
import { ScaVerify } from "../../ScaAirwallex/ScaVerify";

/**
 * SCA verification step for bank transfer approve (same pattern as ViewPin).
 * On success, parent retries approve API with sca_token.
 */
export const ScaStep = ({
  scaSessionCode,
  onVerificationSucceed,
  onVerificationFailed,
  onCancel,
  loading,
}) => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title">Verification <span className="yellow">Required</span></h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
      </div>
    </div>
    {
      loading ? (
        <div className="popup-body-content" style={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: "150px",
          position: 'relative',
        }}>
          <div class="ajax-progress ajax-progress-throbber"><div class="throbber"></div></div>
        </div>
      ) :
        <ScaVerify
          key="authorise-bank-transfer-sca"
          scaSessionCode={scaSessionCode}
          onVerificationSucceed={onVerificationSucceed}
          onVerificationFailed={onVerificationFailed}
          onCancel={onCancel}
        />
    }
  </>
);
